import firebase from './firebase';
const firestore = firebase.firestore();

export default firestore;


// WEBPACK FOOTER //
// ./src/engine/db.js